module.exports = __webpack_public_path__ + "img/ipars.c96bcca2.jpg";